module.exports = __webpack_public_path__ + "media/react/assets/images/cellere-black-1f9aefdeb3c37cd2d598a007cd2ec121.png";